import React from 'react';
import { formatPhoneNum } from '../AppointmentHelpers';
import './OnlineAppointmentsUnavailable.scss';

const OnlineAppointmentsUnavailable = ({ dealerSummary, country, translations = {} }) => {
    const serviceDepartment = dealerSummary?.departments?.find(
        (department) => department.name?.toUpperCase() === 'SERVICE'
    );
    const phoneNumber = serviceDepartment?.phoneNumber == null ? '' : String(serviceDepartment.phoneNumber).trim();
    const formattedPhoneNumber = phoneNumber ? formatPhoneNum(phoneNumber, country) : '';
    const telephoneUri = phoneNumber ? `tel:${phoneNumber}` : '';

    return (
        <div className="appointment-main-container online-appointments-unavailable">
            <p className="online-appoiment-error">
                {translations.DEALER_SETUP_ONLINE_APPOINTMENTS || 'DEALER_SETUP_ONLINE_APPOINTMENTS'}
            </p>
            <p className="online-appointments">{translations.ONLINE_APPOINTMENTS || 'ONLINE_APPOINTMENTS'}</p>
            {formattedPhoneNumber && (
                <p className="online-appointments-desktop-phone">{formattedPhoneNumber}</p>
            )}
            <div className="online-appointments-call-button">
                <a
                    id="btnSignIn"
                    className="button primary-button sign-in"
                    href={telephoneUri || undefined}
                    data-phone-uri={telephoneUri}
                >
                    {translations.CALL_DEALERSHIP || 'CALL_DEALERSHIP'}
                </a>
            </div>
        </div>
    );
};
export default OnlineAppointmentsUnavailable;
